// Chakra imports
import {
    Box,
    Flex,
    Text,
    Badge,
  } from "@chakra-ui/react";
  import Card from "components/card/Card.js";
  import React from "react";
  import { MdArrowUpward, MdArrowDownward } from "react-icons/md";
  import { Icon } from "@chakra-ui/react";
  
  export default function MaterialStatCard(props) {
    const { 
      title, 
      value, 
      percentage, 
      isPositive = true, 
      iconColor = "#459CE9",
      subtitle = "",
      icon: CustomIcon
    } = props;
  
    // Couleurs selon le type de badge
    const badgeBg = isPositive ? "#EAF8FA" : "#FFEEF3";
    const badgeBorder = isPositive ? "rgba(41,186,205,0.2)" : "rgba(248,40,90,0.2)";
    const badgeText = isPositive ? "#29BACD" : "#F8285A";
    const badgeIcon = isPositive ? MdArrowUpward : MdArrowDownward;
  
    return (
      <Card p="20px" borderRadius="12px" border="1px solid #E5E5E5" position="relative" bg="white">
        <Flex gap="10px" alignItems="flex-start" h="100%">
          <Flex flex="1" flexDirection="column" gap="10px" minH="82px">
            <Text
              fontSize="14px"
              fontWeight="400"
              color="#656C7A"
              lineHeight="14px"
              fontFamily="Poppins, sans-serif">
              {title}
            </Text>
            
            <Flex gap="10px" alignItems="end">
              <Text
                fontSize="28px"
                fontWeight="600"
                color="#455879"
                lineHeight="30px"
                letterSpacing="-0.56px"
                fontFamily="Oswald, sans-serif">
                {typeof value === 'number' ? value.toLocaleString('fr-FR') : value}
              </Text>
              
              {percentage && (
                <Badge
                  bg={badgeBg}
                  border={`1px solid ${badgeBorder}`}
                  borderRadius="4px"
                  p="3px"
                  display="flex"
                  alignItems="center"
                  gap="5px"
                  h="auto">
                  <Icon
                    as={badgeIcon}
                    w="12px"
                    h="12px"
                    color={badgeText}
                  />
                  <Text
                    fontSize="12px"
                    fontWeight="500"
                    color={badgeText}
                    lineHeight="12px"
                    fontFamily="Poppins, sans-serif">
                    {percentage}
                  </Text>
                </Badge>
              )}
            </Flex>
            
            {subtitle && (
              <Flex gap="10px" alignItems="center" w="100%">
                <Text
                  fontSize="12px"
                  fontWeight="400"
                  color="#656C7A"
                  lineHeight="14px"
                  fontFamily="Poppins, sans-serif"
                  whiteSpace="pre-wrap">
                  {subtitle}
                </Text>
              </Flex>
            )}
          </Flex>
          
          <Box
            position="absolute"
            top="20px"
            right="20px"
            w="24px"
            h="24px">
            {CustomIcon && (
              <Icon as={CustomIcon} w="24px" h="24px" color={iconColor} />
            )}
          </Box>
        </Flex>
      </Card>
    );
  }

